import { ICmsPromotionalMessage } from '@features/cms/typescript';
import { TIcon } from '@components/icons/typescript';
import { ICmsLink } from '@components/typescript';
import prepareURLByCMSLink from '@utils/prepareURLByCMSLink';
import { IconList } from '@components/icons/components';
export default class CmsPromotionalMessage {
  text: string | undefined;
  icon: TIcon | undefined;
  link: ICmsLink | null | undefined;
  constructor(data: ICmsPromotionalMessage) {
    this.text = data.text;
    this.icon = data.icon;
    this.link = data.link;
  }
  public getText = () => this.text;
  public getIcon = () => this.icon;
  public getIconType = (): TIcon | null => this.icon && IconList.includes(this.icon) ? this.icon : null;
  public hasIcon = (): boolean => this.icon && !!this.getIconType() || false;
  public getLink = () => this.link;
  public hasLink = (): boolean => this.link ? prepareURLByCMSLink(this.link) !== '#' : false;
  public getPrepareLink = (): string | null => this.link && this.hasLink() ? prepareURLByCMSLink(this.link) : null;
}